import { DefaultDocEmoji } from 'components/DefaultDocEmoji/DefaultDocEmoji'
import { memo } from 'react'

type DocEmojiProps = {
  emoji: string | null
  className?: string
}

export const DocEmoji = memo(
  ({ emoji, className }: DocEmojiProps): JSX.Element =>
    emoji ? <span className={className}>{emoji}</span> : <DefaultDocEmoji className={className} />,
)
